import styled from 'styled-components';
import { List } from '@pearsontechnology/aero-components';
import { Link as ReactLink } from 'react-router-dom';
import color from 'tinycolor2';

export const ContentWrapper = styled.div`
  padding: 0 40px 20px;
  color: ${(props) => props.theme['color.text.light']};
`;

export const TitleWrapper = styled.div`
  flex: 1;
  height: 30px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const HeaderNextSection = styled.div`
  display: inline-flex;
  padding-left: 10px;
  padding-right: 10px;
  transform: translateY(6px);
`;

export const MainDescription = styled.div`
  margin-top: 30px;

  color: ${(props) => props.theme['color.text.body']};
  font-size: 16px;
  line-height: 24px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
`;

export const Subtitle = styled.div`
  margin-top: 4px;
  color: ${(props) => props.theme['color.text.body']};
  font-size: 16px;
  line-height: 19px;
`;

export const TitlesWrapper = styled.div`
  color: ${(props) => props.theme['color.text.title']};
  font-size: 24px;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.div`
  margin-right: 10px;
  padding: 6px 10px;
  height: 26px;
  color: ${(props) => props.theme['chip.text.color']};
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.8px;
  background-color: ${(props) => color(props.theme['color.text.body']).setAlpha(0.1).toString()};
  border-radius: 13px;
  line-height: 14px;
`;

export const IconWrapper = styled.div`
  margin-right: 14px;
  align-self: center;
`;

export const UpdateHeader = styled.div`
  align-items: center;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
`;

export const UpdateTitle = styled.div`
  color: ${(props) => props.theme['color.text.body']};
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  display: flex;
`;

export const UpdateVersion = styled.div`
  margin-left: 19px;
  font-weight: 100;
  color: ${(props) => props.theme['color.text.light']};
  font-size: 16px;
  line-height: 19px;
`;

export const UpdateDescription = styled.div`
  margin-top: 16px;
  color: ${(props) => props.theme['color.text.body']};
  font-size: 16px;
  line-height: 24px;
`;

export const UpdateList = styled(List)`
  padding-left: 20px;
`;

export const PluginDetails = styled.div`
  margin-top: 30px;
  color: ${(props) => props.theme['color.text.title']};
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
`;

export const PluginStatusWrapper = styled.div`
  display: flex;
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const PluginStatus = styled.div`
  width: 100%;
  font-size: 14px;
  color: ${(props) => props.theme['color.text.body']};
  font-weight: 600;
  line-height: 18px;
`;

export const PluginContactCardWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
`;

export const PluginContactDetails = styled.div`
  justify-content: space-between;
  display: flex;
  font-weight: 100;
  color: ${(props) => props.theme['color.text.light']};
  font-size: 14px;
  line-height: 18px;
  padding: 8.5px 0;
  border-bottom: ${(props) => props.borderBottom ? `solid ${props.theme['color.border']} 1px` : 'none'};
`;

export const Details = styled.div`
  justify-content: space-between;
  padding-left: 10px;
  font-weight: 100;
  color: ${(props) => props.theme['color.primary.text']};
  font-size: 14px;
  line-height: 18px;
`;

export const DetailsWrapper = styled.div`
  padding: 0;
`;

export const Placeholder = styled.div`
  display: flex;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  border-radius: ${(props) => (props.height / 2)}px;
  background-color: ${(props) => color(props.theme['color.text.light']).setAlpha(color(props.theme['color.primary']).getAlpha() * 0.8).toString()};
  opacity: 0.1;
  flex: 1;
`;

export const PlaceholderIcon = styled.div`
  display: flex;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  border-radius: ${(props) => (props.height / 2)}px;
  background-color: ${(props) => color(props.theme['color.primary']).setAlpha(0.85).toString()};
  opacity: 0.3;
  flex: 1;
`;

export const StyledLink = styled(ReactLink)`
  text-decoration: none;
  color: ${(props) => props.theme['color.primary.text']};
  border-bottom: solid ${(props) => color(props.theme['color.primary.text']).setAlpha(0.2).toString()} 2px;
`;

export const SetupLink = styled(ReactLink)`
  text-decoration: none;
  color: ${(props) => props.theme['color.primary.text']};
`;

export const PluginSetup = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
`;

export const PluginSettingsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  line-height: 38px;
  font-weight: 600;
`;

export const CheckboxWrapper = styled.div`
  margin-top: 4px;
  margin-left: auto;
`;

export const SharingWrapper = styled.div`
  justify-content: space-between;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme['color.text.body']};
`;

export const SchemaBlock = styled.pre`
  font-size: 12px;
  overflow-x: auto;
  max-height: 300px;
  margin: 0;
  white-space: pre-wrap;
  color: ${(props) => props.theme['color.text.body']};
`;
